export const HOLDINGS_PAGE_SIZE = 100;
